
const intervalId = setInterval(()=> {
    const NEW_ICON_URL = window.salepifyAssets;
    const img = document.querySelector(".salepify-embed-widget__header-icon")
    if(window.tlFreeGiftOffer.embedWidget && img ) {
        clearInterval(intervalId)
        img.src = NEW_ICON_URL
    }
}, 100)
setTimeout(()=> {
    clearInterval(intervalId)
}, 3000)
